

















import Vue from 'vue';
import helpers from '@/lib/helpers';
import Fetch from '@/lib/fetch.ts';
import { Post } from '@/lib/types.ts';
import { Route } from 'vue-router';

export default Vue.extend({
    data() {
        return {
            post: {} as Post,
            helpers,
        };
    },
    async beforeRouteEnter(to: Route, from: Route, next: (vm: any) => void) {
        next(async (vm: any) => {
            vm.post = await Fetch.get(`/api/singlepost/${ vm.$route.params.link }`);
        });
    },
});
